'use strict';

import React from 'react';
import appConstants from 'constants/appConstants';

import Page from 'components/base/Page';
import PageTitle from 'components/base/PageTitle';

import LeaveApply from 'components/profile/sections/LeaveApply';

import modalActions from 'actions/ModalActionCreators';
import personActions from 'actions/PersonActionCreators';

import authStore from 'stores/AuthStore';
import teamStore from 'stores/TeamStore';
import personStore from 'stores/PersonStore';

import PageRow from 'components/base/PageRow';

import PageSection from 'components/base/PageSection';
import WidgetButton from 'components/base/WidgetButton';
import ProfileWidget from 'components/home/ProfileWidget';
import LeaveBalanceWidget from 'components/home/LeaveBalanceWidget';
import PendingProfileApprovalsWidget from 'components/home/PendingProfileApprovalsWidget';
import PendingLeaveApprovalsWidget from 'components/home/PendingLeaveApprovalsWidget';
import NewStartersWidget from 'components/home/NewStartersWidget';
import NextLeaveWidget from 'components/home/NextLeaveWidget';
import YourManagerWidget from 'components/home/YourManagerWidget';
import AllTeamMembersButtonWidget from 'components/home/AllTeamMembersButtonWidget';
import MembersOnLeaveWidget from 'components/home/MembersOnLeaveWidget';
import MembershipTeamWidget from 'components/home/MembershipTeamWidget';
import ManagementTeamWidget from 'components/home/ManagementTeamWidget';
import PayAdviceWidget from 'components/home/PayAdviceWidget';
import AuditLogsWidget from 'components/home/AuditLogsWidget';
import Salvatrix from 'components/base/Salvatrix';
import 'styles/Home.scss';

import _ from 'underscore';
import utils from 'services/utils';
import moment from 'moment';

class Home extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            person: null,
        };
    }

    componentDidMount() {        
        authStore.addChangeListener(this.onChange);
        personStore.addChangeLoginPersonListener(this.onLoginPersonChange);
        personStore.addChangeListener(this.onPersonChange);
        teamStore.addChangeListener(this.onTeamChange);
        this.onLoginPersonChange();
        this.handleRedirect();
        this.getApprovals();
    }

    componentWillUnmount() {
        authStore.removeChangeListener(this.onChange);
        personStore.removeChangeListener(this.onPersonChange);
        personStore.removeChangeLoginPersonListener(this.onLoginPersonChange);
        teamStore.removeChangeListener(this.onTeamChange);
    }

    getApprovals = () => {
        if ((this.props.userInfo !== undefined && this.props.userInfo.isLoggedIn) && (!this.props.userInfo.isNewStarter)  && (!this.props.approvalsData || !this.props.approvalsData.loading)) {
            this.props.getApprovals();
        }
    };

    onLoginPersonChange = () => {
        if (this.props.userInfo && this.props.userInfo.person) {
            personStore.extendLoggedUserToCurrentUser();
            this.onPersonChange();
        }
    };

    onChange = () => {
        const userInfo = authStore.getLoggedInUserData();
        userInfo.isNewStarter = false;

        const customData = JSON.parse(userInfo?.user?.profile?.idTokenClaims.custom_data);
        const workflowitemid = customData.WorkflowItemId;

        if (userInfo.user && userInfo.user.profile && workflowitemid > 0) {
            userInfo.isNewStarter = true;
        }
    };

    handleRedirect() {
        if (this.props.userInfo !== undefined && this.props.userInfo.isLoggedIn) {
            if (this.props.userInfo.isNewStarter !== undefined && this.props.userInfo.isNewStarter) {
                this.props.router.push({
                    pathname: '/teams/new-starters/landing/',
                });
            } else if (!this.props.permissions.isVisible('DashboardDisplay')) {
                const userId = this.props.userInfo.person.Id;
                this.props.router.push({
                    pathname: `/members/${userId}/personal-information/`,
                });
            }
        }
    }

    onPersonChange = () => {
        var _person = personStore.getPerson();

        const isInUnassigned = _.find(_person.person.Memberships, function (membership) {
            return membership.Team.IsDefaultTeam === true;
        });
        const isInUnassignedOnly = isInUnassigned && _person.person.Memberships.length === 1 && !_person.person.AdminRole;

        if (_person) {
            this.setState({
                person: _person.person,
                isInUnassignedOnly,
            });
        }
    };

    onTeamChange = () => {
        var _teams = teamStore.getTeamData();
        if (_teams) {
            this.setState({ teams: _teams });
        }
    };

    handleApplyLeaveButtonClick = (event) => {
        utils.preventDefault(event);
        var content = (
            <LeaveApply
                {...this.props}
                person={this.state.person}
                onAppliedCallback={this.handleAppliedLeaveCallback}
            />
        );
        modalActions.showModal(content, "double");
    };

    handleAppliedLeaveCallback = () => {
        const model = {
            Name: "Upcoming",
            PageNumber: 1,
            RecordsPerPage: 1,
            LeaveStatusList: [
                appConstants.ENUMS.LEAVE_STATUS.PENDING,
                appConstants.ENUMS.LEAVE_STATUS.APPROVED,
                appConstants.ENUMS.LEAVE_STATUS.IN_APPROVAL,
            ],
            StartDate: moment().format(appConstants.dates.formats.SERVER_POST_FORMAT),
            SortingType: 0,
            IsSortingDesc: false,
        };

        setTimeout(() => {
            personActions.getSinglePersonLeave(this.state.person.Id, model);
        }, 0);
    };

    getApprovalWidgetsToDisplay = () => {

        let displayLeaveApprovalsWidget = false;
        let displayPersonalChangesApprovalsWidget = false;

        const approverTypesSet = new Set(this.props.userInfo.person.ApproverTypes);

        if (approverTypesSet.size > 0) {
            const canDisplayPersonalChangesWidget = this.props.permissions && this.props.permissions.isVisible("ApprovePersonalChanges");
            if (approverTypesSet.has(appConstants.ENUMS.APPROVER_TYPES.ADMIN)
                || approverTypesSet.has(appConstants.ENUMS.APPROVER_TYPES.MANAGER)
                || approverTypesSet.has(appConstants.ENUMS.APPROVER_TYPES.REDIRECTED_APPROVER)
            ) {
                displayLeaveApprovalsWidget = true;
                displayPersonalChangesApprovalsWidget = canDisplayPersonalChangesWidget;
            } else {
                if (approverTypesSet.has(appConstants.ENUMS.APPROVER_TYPES.OUT_OF_TEAM_APPROVER_FOR_LEAVE)) {
                    displayLeaveApprovalsWidget = true;
                }

                if (approverTypesSet.has(appConstants.ENUMS.APPROVER_TYPES.OUT_OF_TEAM_APPROVER_FOR_PERSONAL_CHANGES)) {
                    displayPersonalChangesApprovalsWidget = true;
                }
            }
        }

        return [
            displayLeaveApprovalsWidget,
            displayPersonalChangesApprovalsWidget,
        ];
    };

    render() {

        var p = this.props.permissions;
        var content;

        if (this.props.userInfo.isLoggedIn) {
            if (p && p.permissions && this.state.person && this.state.person.Id) {

                var person = this.state.person;


                /* PROFILE AND TASKS */
                var profileSections = [];

                profileSections.push(<ProfileWidget key="0" person={person} />);

                const [displayLeaveApprovalsWidget, displayPersonalChangesApprovalsWidget] = this.getApprovalWidgetsToDisplay(); 

                if (displayLeaveApprovalsWidget) {
                    profileSections.push(<PendingLeaveApprovalsWidget key="1" approvalsData={this.props.approvalsData} />);
                }

                if (displayPersonalChangesApprovalsWidget) {
                    profileSections.push(<PendingProfileApprovalsWidget key="2" approvalsData={this.props.approvalsData} />);
                }

                if (this.props.permissions.isVisible("NewStarters")) {
                    profileSections.push(<NewStartersWidget key="profile-new-starters" />);
                }

                if (p.isVisible("PayAdvice", appConstants.ENUMS.ROLE_TYPES.EMPLOYEE)) {
                    profileSections.push(<PayAdviceWidget key="3" person={person} />);
                }

                var profileRow = "";
                if (profileSections.length > 0) {
                    profileRow = (<PageRow compactSections key="0">{profileSections}</PageRow>);
                }

                /*****************/

                /* LEAVE */
                var leaveSections = [];

                if (p.isVisible("Leave", appConstants.ENUMS.ROLE_TYPES.EMPLOYEE)) {

                    if (p.isEditable("Leave", appConstants.ENUMS.ROLE_TYPES.EMPLOYEE)) {
                        leaveSections.push(<PageSection id="apply-for-leave-widget" key="0" backgroundColorClass="background-color-leave" halfSize onClick={this.handleApplyLeaveButtonClick}><WidgetButton heading="Apply for Leave" iconName="icon-apply-for-leave" /></PageSection>);
                    }
                    leaveSections.push(<LeaveBalanceWidget key="1" person={person} />);
                    leaveSections.push(<NextLeaveWidget {...this.props} key="2" person={person} />);

                }

                if (p.isVisible("WhosOnLeave")) {
                    leaveSections.push(<MembersOnLeaveWidget key="3" teams={this.state.teams} />);
                }

                var leaveRow = "";
                if (leaveSections.length > 0) {
                    leaveRow = (<PageRow compactSections reduceMargin key="1">{leaveSections}</PageRow>);
                }
                /************/

                /* PEOPLE AND TEAM */

                var teamSections = [];

                if (p.isVisible("MemberDirectoryForAllMembers")) {
                    teamSections.push(<PageSection id="directory-widget" key="0" backgroundColorClass="background-color-info" halfSize link="/teams/everyone/"><WidgetButton heading="Directory" iconName="icon-people" /></PageSection>);
                }

                if (p.isVisible("Teams", appConstants.ENUMS.ROLE_TYPES.EMPLOYEE) && !this.state.isInUnassignedOnly) {

                    teamSections.push(<AllTeamMembersButtonWidget key="2" person={person} />);
                    teamSections.push(<YourManagerWidget permissions={this.props.permissions} key="1" person={person} teams={this.state.teams} />);
                    teamSections.push(<MembershipTeamWidget key="3" person={person} />);
                    teamSections.push(<ManagementTeamWidget key="4" person={person} />);
                }

                var teamRow = "";
                if (teamSections.length > 0) {
                    teamRow = (<PageRow compactSections reduceMargin key="2">{teamSections}</PageRow>);
                }

                /* AUDIT REPORTS */
                let auditLogRow;
                if (p.isVisible("AuditReports", appConstants.ENUMS.ROLE_TYPES.ADMINISTRATOR)) {
                    auditLogRow = (
                        <PageRow compactSections reduceMargin>
                            <AuditLogsWidget />
                        </PageRow>
                    );
                }

                content = (
                    <span className="dashboard">
                        <div className="page-header">
                            <PageTitle
                                selectable={false}
                                title={(
                                    <Salvatrix
                                        userInfo={this.props.userInfo}
                                        approvalsData={this.props.approvalsData}
                                    />
                                )}
                            />
                        </div>
                        {profileRow}
                        {leaveRow}
                        {teamRow}
                        {auditLogRow}
                    </span>
                );
            } else {
                content = (
                    <span></span>
                );
            }

        } else {
            content = (
                <span></span>
            );
        }


        return (
            <Page 
                {...this.props}
                showInlineNotifications
            >
                {content}
            </Page>
        );
    }
}

export default Home; 
